import { render, staticRenderFns } from "./QuickSightReportManage.vue?vue&type=template&id=4f3ba3fb"
import script from "./QuickSightReportManage.vue?vue&type=script&lang=ts"
export * from "./QuickSightReportManage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports